module.exports = DDC.WsmCommonData;


//////////////////
// WEBPACK FOOTER
// external "DDC.WsmCommonData"
// module id = 64
// module chunks = 0